import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background-color":"white"} }

import { onMounted, ref } from 'vue'
import { Alarm, AlarmClient, DASChart } from '@/server/MakeSenseApp-backend'
import DASChartComponent from '../DasChart.vue'
import { useProjectStore } from '@/stores/ProjectStore'
import { requiredInject } from '@/utilities/requiredInject'


export default /*@__PURE__*/_defineComponent({
  __name: 'AlarmDASChart',
  props: {
  alarm: Alarm
},
  setup(__props) {

const props = __props

const chartData = ref<DASChart | undefined>(undefined)
let store = useProjectStore()

onMounted(() => {
  const alarmClient = requiredInject<AlarmClient>('AlarmClient')

  if (props.alarm === undefined || props.alarm.id === undefined) {
    console.error('Alarm ID is undefined')
    return
  }

  alarmClient.dasForAlarm(store.projectId, props.alarm.id).then((data) => {
    chartData.value = data as DASChart
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("h5", null, "Distributed Acoustic Sensing (DAS)", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(DASChartComponent, { data: chartData.value }, null, 8, ["data"])
    ])
  ]))
}
}

})